import { OrderManagementFormSchema } from '../types/orderManagementSchema';

type ExtraValues = {
  boilerMaintenancePrice?: number;
  serviceProposalPrice?: number;
};

export const getTrackableFormValues = (formstate: OrderManagementFormSchema, extraValues?: ExtraValues) => {
  const {
    deliveryAddressStep: {
      houseNumber: _houseNumber,
      street: _street,
      isApiPostalCodeCityValid: _isApiPostalCodeCityValid,
      busNumber: _busNumber,
      correspondenceAddress: {
        busNumber: __busNumber,
        houseNumber: __houseNumber,
        isApiPostalCodeCityValid: __isApiPostalCodeCityValid,
        street: __street,
        ...restCorrespondenceAddress
      } = {},
      ...restDeliveryAddress
    } = {},
    electricityDetailsStep: {
      eanCode: _eanCode,
      eanCodeNightExclusiveCode: _eanCodeNightExclusiveCode,
      eanCodeNightExclusiveMeterNumber: _eanCodeNightExclusiveMeterNumber,
      eanCodeNightExclusiveOfMeter: _eanCodeNightExclusiveOfMeter,
      eanCodeOfMeter: _eanCodeOfMeter,
      meterNumber: _meterNumber,
      ...restElectricityDetails
    } = {},
    gasDetailsStep: {
      eanCode: _gasEanCode,
      meterNumber: _gasMeterNumber,
      eanCodeOfMeter: __eanCodeOfMeter,
      ...restGasDetails
    } = {},
    selectPaymentMethod: { ibanNumber: _ibanNumber, ...restPayment } = {},
    overviewStep: { gezinsbondMembershipNumber: _gezinsbondMembershipNumber, ...restOverview } = {},
    ...legallyAllowedRootFormState
  } = formstate;

  const { boilerMaintenancePrice, serviceProposalPrice } = extraValues ?? {};

  const legallyAllowedFormState = {
    ...legallyAllowedRootFormState,
    deliveryAddressStep: {
      ...restDeliveryAddress,
      correspondenceAddress: restCorrespondenceAddress,
    },
    electricityDetailsStep: restElectricityDetails,
    gasDetailsStep: restGasDetails,
    selectPaymentMethod: restPayment,
    overviewStep: restOverview,
    boilerMaintenancePrice,
    serviceProposalPrice,
  };

  return legallyAllowedFormState;
};
